import { getGetImmaginiUidQueryKey } from '@framework/api-client/api/inquiries/immagini-controller/immagini-controller.ts';
import { joinPath } from '@framework/api-client/utils/joinPath.ts';
import { type LanguageTag } from '@framework/i18n/config.ts';
import { appConfig } from '../../../../core/appConfig.ts';

export function getImageUrl(
  id: string | null | undefined,
  language: LanguageTag,
) {
  if (!id) return '';
  const uri = getGetImmaginiUidQueryKey(id)[0] as string;

  const additionalParams = `?lingua=${language}`;

  return joinPath([appConfig.apiBaseUrl, uri + additionalParams]);
}
